export enum RecurringInstructStatus {
    INPROGRESS = "IN_PROGRESS",
    SUCCESS = "SUCCESS",
    EXPIRED = "EXPIRED",
    FAILED = "FAILED",
}

export const mapStringToRecurringInstructStatus = (
    status: string
): RecurringInstructStatus => {
    const match = (Object.values(RecurringInstructStatus) as string[]).find((v) => v === status);
    if (!match) {
        return RecurringInstructStatus.INPROGRESS;
    }
    return match as RecurringInstructStatus
};

export const isRecurringInstructSuccess = (status: RecurringInstructStatus): boolean =>
    status === RecurringInstructStatus.SUCCESS;

export const isRecurringInstructFail = (status: RecurringInstructStatus): boolean =>
    status === RecurringInstructStatus.FAILED || status === RecurringInstructStatus.EXPIRED;

export const isRecurringInstructInProgress = (status: RecurringInstructStatus): boolean =>
    (!isRecurringInstructSuccess(status) && !isRecurringInstructFail(status));